import {
  Box,
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import React, { useState } from "react";
import logo from "../assets/pisaBar.svg";
import { useNavigate } from "react-router-dom";
import path from "path";

function Navbar() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const navLinks = [
    { label: "Home", path: "/" },
    // { label: "Our Thinking", path: "/OurThinking" },
    { label: "Menu", path: "/crush-coffee" },
    { label: "Chi siamo", path: "/about" },
    // { label: "Careers", path: "/Careers" },
    { label: "Viaggi", path: "/Tours" },
    { label: "Contatti", path: "/Contact" },
    //{ lavel: "Vacanza", path: "/tours" },
  ];

  const toggleDrawer = (open: boolean) => () => {
    setOpenDrawer(open);
  };

  const handleNavigation = (path: string) => {
    navigate(path);
    setOpenDrawer(false);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="absolute" // or "fixed" for a sticky navbar
        // backgroundColor: "#000",
        sx={{
          background:
            "linear-gradient(to bottom, rgba(0, 0, 0, 0.9), rgba(255, 255, 255, 0))",
          width: "100%",
          boxShadow: "none",
          zIndex: 10,
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between", pl: 0 }}>
          {/* Logo */}
          <Box
            component="img"
            src={logo}
            alt="Logo"
            sx={{ width: 150, pt: 0, cursor: "pointer" }}
            onClick={() => navigate("/")}
          />

          {/* Desktop navigation */}
          {!isMobile && (
            <Box sx={{ display: "flex", gap: 2 }}>
              {navLinks.map((link) => (
                <Button
                  key={link.path}
                  onClick={() => navigate(link.path)}
                  sx={{
                    color: "#fff",
                    fontWeight: 500,
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "transparent",
                      textDecoration: "underline",
                    },
                  }}
                >
                  {link.label}
                </Button>
              ))}
            </Box>
          )}

          {/* Mobile hamburger menu */}
          {isMobile && (
            <>
              <IconButton
                size="large"
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={toggleDrawer(true)}
              >
                <MenuIcon />
              </IconButton>

              <Drawer
                anchor="right"
                open={openDrawer}
                onClose={toggleDrawer(false)}
                PaperProps={{ sx: { width: "70%" } }}
              >
                <List>
                  {navLinks.map((link) => (
                    <ListItem key={link.path} disablePadding>
                      <ListItemButton
                        onClick={() => handleNavigation(link.path)}
                      >
                        <ListItemText primary={link.label} />
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              </Drawer>
            </>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default Navbar;
